<script>
    import { Router, Route } from 'svelte-routing';

    // Layouts
    import Receiver from './layouts/ReceiverLayout.svelte';
    import Comparator from './layouts/ComparatorLayout.svelte';
    import Purchase from './layouts/PurchaseLayout.svelte';
    import Offers from './layouts/OffersLayout.svelte';

    // Pages
    import Index from './views/Index.svelte';
    import Home from './views/Home.svelte';
    import Clean from './tools/CleanView.svelte';
    import Store from './tools/StoreView.svelte';
    import Offer from './tools/OfferView.svelte';
    import Head from './components/Head.svelte';

    export let url = '';
    export let name = '';
</script>

<Router {url}>
    <Head />
    <!-- layouts -->
    <Route path="/receiver/*rec" component={Receiver} />
    <Route path="/comparador/*compara" component={Comparator} />
    <Route path="/compra/*compra" component={Purchase} />
    <Route path="/offers/*offer" component={Offers} />

    <!-- pages -->
    <Route path="/index" component={Index} />
    <Route path="/" component={Home} />
    <Route path="/clean" component={Clean} />
    <Route path="/store" component={Store} />
    <Route path="/offer" component={Offer} />
</Router>
